import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeMode = 'light' | 'dark' | 'auto'

interface ThemeState {
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
}

const applyTheme = (mode: ThemeMode) => {
  const root = document.documentElement

  if (mode === 'auto') {
    // Remove data-theme to let CSS media query handle it
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', mode)
  }
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'auto',
      setMode: (mode) => {
        applyTheme(mode)
        set({ mode })
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        // Apply theme after rehydration from localStorage
        if (state) {
          applyTheme(state.mode)
        }
      },
    }
  )
)

// Initialize theme on module load
const initializeTheme = () => {
  const stored = localStorage.getItem('theme-storage')
  if (stored) {
    try {
      const { state } = JSON.parse(stored)
      if (state?.mode) {
        applyTheme(state.mode)
      }
    } catch {
      // Invalid stored value, will use default
    }
  }
}

// Run immediately to prevent flash
initializeTheme()
